import { Box } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import type { CatalogIcon } from '@rover/react-lib/src/pages/shared/serviceCatalog/types';

const ICON_SIZE = { width: '25px', height: '25px' };
const CIRCLE_SIZE = { width: '32px', height: '32px' };

type ServiceIconProps = {
  icon: CatalogIcon;
};

/** Renders a service's catalog icon inside its color-scheme circle. */
const ServiceIcon = ({ icon }: ServiceIconProps): JSX.Element => {
  const theme = useTheme();
  const { component: Icon, colorScheme } = icon;

  return (
    <Box position="relative">
      <Box
        backgroundColor={theme.colors[colorScheme]['200']}
        borderRadius="round"
        {...CIRCLE_SIZE}
      />
      <Box position="absolute" top="4px" left="4px">
        <Icon style={{ ...ICON_SIZE, fill: theme.colors[colorScheme]['700'] }} />
      </Box>
    </Box>
  );
};

export default ServiceIcon;
